export default __webpack_public_path__ + "static/media/success-active.3b3583e6.svg";